/**
 * Redirects to the post-application page for a given loan ID.
 * Automatically determines the correct base URL based on the current path
 * (technician vs homeowner flow).
 *
 * @param loanId - The ID of the loan to redirect to
 */
export const redirectToPostApplication = (loanId: string) => {
    const normalizedLoanId = loanId || '0';
    const currentPath = window.location.pathname;
    const baseUrl = currentPath.startsWith('/technician-')
        ? '/technician-post-application'
        : '/post-application';

    const redirectUrl = `${baseUrl}/loans/${normalizedLoanId}`;
    window.location.href = redirectUrl;
};
